// extracted by mini-css-extract-plugin
export default {"reviewsContainer":"ReviewContainer_reviewsContainer__oGo0p","reviewsInnerContainer":"ReviewContainer_reviewsInnerContainer__Ji4cv"};